var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3DDC84",
    d: "M68.223 35.86a3.548 3.548 0 1 1-.002-7.095 3.548 3.548 0 0 1 .002 7.095m-39.212 0a3.548 3.548 0 1 1-.001-7.095 3.548 3.548 0 0 1 .001 7.095m40.484-21.369 7.09-12.28A1.476 1.476 0 0 0 74.03.736l-7.179 12.434c-5.49-2.505-11.655-3.9-18.234-3.9s-12.744 1.397-18.234 3.9L23.203.735A1.474 1.474 0 1 0 20.65 2.21l7.09 12.281C15.565 21.113 7.238 33.438 6.02 47.999h85.196c-1.22-14.561-9.546-26.886-21.72-33.508"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 0h85.195v48H6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/Android.8454c99d3425ba302afea8f2cfb4b8ea.svg";
export { ForwardRef as ReactComponent };